module.exports = __webpack_public_path__ + "img/1.3b1b9ae3.jpg";